<footer>
  <div>
    <span>{{ 'FOOTER.VERSION' | i18nextEager }} 1.0 © - Acciona 2021</span>
  </div>
  <div>
    <span class="link" (click)="openModal('cookies')">{{ 'FOOTER.COOKIES' | i18nextEager }}</span>
    <span class="link" (click)="openModal('privacy')">{{ 'FOOTER.PRIVACY_POLICY' | i18nextEager }}</span>
  </div>
</footer>
